import { styled } from "@mui/system"

import { isBaseColor } from "../../utils/isBaseColor"

import { Chip as UiChip, ChipSkeleton as UiChipSkeleton } from "../Chip"
import { ChipAdd as L2rChipAdd } from "../ChipAdd"

const ICON_SMALL = 24

type AdditionalChipProps = {
    color: string,
    textColor?: string,
}

export const Chip = styled(UiChip)<AdditionalChipProps>(({ color, textColor, theme }) => {
    if (!isBaseColor(color)) {
        return ({
            backgroundColor: theme.palette[color].main,
            borderColor: theme.palette[color].main,
            color: theme.palette?.[textColor]?.main || theme.palette.common.white,

            "& .MuiChip-deleteIcon": {
                color: theme.palette.common.white,
                opacity: 0.7,

                "&:hover": {
                    color: theme.palette.common.white,
                    opacity: 1,
                },
            },
            margin: theme.spacing(1),
        })
    } else {
        return ({
            margin: theme.spacing(1),
        })
    }
})

export const ChipSkeletonsWrapper = styled("div")({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
})

export const ChipSkeleton = styled(UiChipSkeleton)(({ theme }) => ({
    margin: theme.spacing(1),
}))

export const ChipAdd = styled(L2rChipAdd)(({ small, theme }) => ({
    "&.MuiIconButton-root": {
        margin: theme.spacing(0, 1),
        height: small && ICON_SMALL,
        width: small && ICON_SMALL,

        "& > *": {
            width: small && 18,
            height: small && 18,
        },
    },
}))

export const ChipsWrapper = styled("div")({
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
})